import React from 'react';

interface YamooPayLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
  onClick?: () => void;
}

export const YamooPayLogo: React.FC<YamooPayLogoProps> = ({
  size = 'md',
  showText = true,
  className = '',
  onClick
}) => {
  const iconSizes = {
    sm: 'w-7 h-7 text-base rounded-lg',
    md: 'w-9 h-9 text-xl rounded-xl',
    lg: 'w-11 h-11 text-2xl rounded-2xl',
    xl: 'w-14 h-14 text-3xl rounded-2xl'
  };

  const textSizes = {
    sm: 'text-lg',
    md: 'text-2xl',
    lg: 'text-3xl',
    xl: 'text-4xl'
  };

  return (
    <div
      onClick={onClick}
      className={`inline-flex items-center gap-2.5 select-none ${onClick ? 'cursor-pointer group' : ''} ${className}`}
    >
      {/* Icon: Green rounded rectangle with bold white 'Y' */}
      <div
        className={`${iconSizes[size]} bg-[#00A669] text-white font-extrabold flex items-center justify-center tracking-tight shadow-xs transition-transform duration-150 ${
          onClick ? 'group-hover:scale-105' : ''
        }`}
        style={{ backgroundColor: '#00A669' }}
      >
        <span>Y</span>
      </div>

      {/* Brand Text: Yamoo in Navy Blue, Pay in Emerald Green */}
      {showText && (
        <span className={`${textSizes[size]} font-extrabold tracking-tight font-sans leading-none flex items-center`}>
          <span className="text-[#0F172A]">Yamoo</span>
          <span className="text-[#00A669]">Pay</span>
        </span>
      )}
    </div>
  );
};
